<main class="products-page">
  <div class="background-glow"></div>
  <app-header></app-header>

  <section class="intro">
    <div class="intro-title">
      <span class="section-tag">PRODUTOS</span>
      <h1>Software que transforma <span>complexidade em clareza.</span></h1>
    </div>
    <p class="intro-copy">Conheça os produtos da SMS Murilo. Cada solução é construída para resolver desafios reais com segurança, desempenho e espaço para evoluir.</p>
  </section>

  <section class="commercial-section" aria-labelledby="commercial-products-title">
    <div class="category-heading">
      <span class="section-tag">PRODUTOS COMERCIAIS</span>
      <h2 id="commercial-products-title">Soluções para impulsionar a operação.</h2>
      <p>Produtos digitais orientados a processos, gestão e crescimento do negócio.</p>
    </div>
    <span class="product-status commercial-product-status">PLATAFORMA COMERCIAL</span>
    <div class="commercial-grid">
      <article class="commercial-card">
        <div class="product-icon orbita-icon"><img src="images/orbita.svg" alt="Logo Órbita"></div>
        <div>
          <h3>Órbita</h3>
          <p>Envie e-mails automáticos e campanhas de marketing, gerencie domínios e caixas postais próprias em um único painel.</p>
          <div class="product-actions">
            <a href="https://www.orbita.smsmurilo.com.br/" target="_blank" rel="noopener noreferrer" class="marketplace-link">Conhecer o Órbita <span>↗</span></a>
            <a href="https://app.orbita.smsmurilo.com.br/contratar" target="_blank" rel="noopener noreferrer" class="product-link">Ver planos <span>→</span></a>
          </div>
        </div>
      </article>
      <article class="commercial-card pagepilot-card">
        <div class="product-icon pagepilot-icon"><img src="images/pagepilot-logo.svg" alt="PagePilot"></div>
        <div>
          <h3>PagePilot</h3>
          <p>Crie, personalize e publique landing pages profissionais com templates, domínio próprio, recursos de mídia e contratação integrada.</p>
          <div class="product-actions">
            <a href="https://pagepilot.com.br/" target="_blank" rel="noopener noreferrer" class="marketplace-link">Conhecer o PagePilot <span>↗</span></a>
            <a href="https://pagepilot.com.br/planos" target="_blank" rel="noopener noreferrer" class="product-link">Ver planos <span>→</span></a>
          </div>
        </div>
      </article>
      <article class="commercial-card ondahub-card">
        <div class="product-icon ondahub-icon"><img src="images/ondahub.png" alt="Logo OndaHub"></div>
        <div class="ondahub-content">
          <h3>OndaHub</h3>
          <span class="ondahub-tagline">A sua rádio no celular</span>
          <p>O OndaHub é a plataforma que leva a rádio para o celular de quem ouve. Cada emissora tem o seu aplicativo, com a sua cara, e conversa com o ouvinte em tempo real.</p>
          <ul class="ondahub-features">
            <li>Rádio ao vivo, inclusive com a tela desligada</li>
            <li>Programação do dia e da semana</li>
            <li>Transmissão em vídeo</li>
            <li>Pedidos de música, recados de voz e WhatsApp</li>
            <li>Clube do ouvinte, enquetes e promoções</li>
            <li>Alertas de utilidade pública do seu bairro</li>
          </ul>
          <div class="product-actions">
            <a href="https://oh.smsmurilo.com.br/" target="_blank" rel="noopener noreferrer" class="marketplace-link ondahub-link">Conhecer o OndaHub <span>↗</span></a>
            <a href="https://oh.smsmurilo.com.br/about.html" target="_blank" rel="noopener noreferrer" class="product-link">Sobre o projeto <span>→</span></a>
          </div>
        </div>
      </article>
      <article class="commercial-card ondahub-card broadcast-card">
        <div class="product-icon ondahub-icon"><img src="images/ondahub-broadcast.png" alt="Logo OndaHub Broadcast"></div>
        <div class="ondahub-content">
          <h3>OndaHub Broadcast</h3>
          <span class="ondahub-tagline">Transmita para o seu público, do seu jeito.</span>
          <p>Aplicativo próprio, programas sob demanda e a sua transmissão em um só lugar, com painel simples e cobrança mensal sem complicação.</p>
          <details class="broadcast-details">
            <summary>Ver recursos da plataforma</summary>
            <ul class="broadcast-services">
              <li><strong>Aplicativo próprio</strong><span>App Android com a sua marca: ao vivo, programação, recados e notificações.</span></li>
              <li><strong>Programas sob demanda</strong><span>Cada programa da grade fica gravado no app para ouvir depois.</span></li>
              <li><strong>Aviso do programa favorito</strong><span>O ouvinte recebe uma notificação quando o programa começa.</span></li>
              <li><strong>Recortes do ao vivo</strong><span>O público compartilha os melhores momentos nas redes sociais.</span></li>
              <li><strong>Relatório do anunciante</strong><span>Comprove aos patrocinadores quantos ouviram cada inserção.</span></li>
              <li><strong>Streaming de áudio</strong><span>Servidor próprio, conexão segura e ouvintes ao vivo no painel.</span></li>
              <li><strong>Automação 24h (AutoDJ)</strong><span>Assume quando o estúdio sai do ar: músicas, vinhetas e comerciais.</span></li>
              <li><strong>Vídeo e lives</strong><span>Transmita pelo OBS ou vMix e o público assiste no app e no site.</span></li>
              <li><strong>Multistream</strong><span>Uma transmissão, ao mesmo tempo no YouTube, Facebook, Instagram e outros.</span></li>
              <li><strong>Live pelo app</strong><span>A equipe entra ao vivo em vídeo direto do celular, sem computador.</span></li>
              <li><strong>Microvídeo do público</strong><span>Vídeos de até 15 segundos enviados pelo app para usar no ar.</span></li>
            </ul>
          </details>
          <div class="product-actions">
            <a href="https://oh.smsmurilo.com.br/broadcast.html" target="_blank" rel="noopener noreferrer" class="marketplace-link ondahub-link">Conhecer o Broadcast <span>↗</span></a>
            <a href="https://oh.smsmurilo.com.br/broadcast.html#planos" target="_blank" rel="noopener noreferrer" class="product-link">Ver planos <span>→</span></a>
          </div>
        </div>
      </article>
      <article class="commercial-card ebookagents-card">
        <div class="product-icon ebookagents-icon"><img src="images/ebookagents.svg" alt="Logo EbookAgents"></div>
        <div>
          <h3>EbookAgents</h3>
          <p>Planeje e revise seus ebooks no Studio e explore publicações no Marketplace EbookAgents.</p>
          <div class="product-actions">
            <a href="https://studio.ebookagents.com.br/" target="_blank" rel="noopener noreferrer" class="marketplace-link">Acessar o Studio <span>↗</span></a>
            <a href="https://www.ebookagents.com.br/" target="_blank" rel="noopener noreferrer" class="product-link">Conhecer o Marketplace <span>↗</span></a>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="category-heading" aria-labelledby="technical-products-title">
    <span class="section-tag">PRODUTOS TÉCNICOS</span>
    <h2 id="technical-products-title">Ferramentas para equipes de engenharia.</h2>
    <p>Produtos voltados à qualidade, arquitetura, desenvolvimento e operação de software.</p>
  </section>

  <section class="products-grid" aria-label="Produtos técnicos SMS Murilo">
    <article class="product-card featured">
      <div class="product-icon architecture-icon">
        <img src="images/architecture-analysis.svg" alt="Logo do Architecture Analysis" class="architecture-logo">
      </div>
      <div class="card-content">
        <span class="product-status">DISPONÍVEL NA JETBRAINS MARKETPLACE</span>
        <h2>Architecture Analysis</h2>
        <p>Uma plataforma de governança arquitetural e inteligência de software para projetos Java e Kotlin no IntelliJ IDEA.</p>
        <ul>
          <li>Identifica violações arquiteturais, dependências circulares e relacionamentos proibidos</li>
          <li>Revela acoplamento excessivo, desvio arquitetural e indicadores de dívida técnica</li>
          <li>Oferece mapeamento de dependências, validação de fronteiras e dashboards de governança</li>
        </ul>
        <div class="product-actions">
          <a href="https://plugins.jetbrains.com/plugin/32537-architecture-analysis" target="_blank" rel="noopener noreferrer" class="marketplace-link">Instalar pela Marketplace <span>↗</span></a>
          <a routerLink="/products/architecture-analysis" class="product-link">Conhecer o produto <span>→</span></a>
        </div>
      </div>
    </article>

    <article class="product-card resilience-card">
      <div class="product-icon resilience-icon">
        <img src="images/smsmurilo-resilience.svg" alt="Ícone do SmsMurilo Resilience">
      </div>
      <div class="card-content">
        <span class="product-status">PLUGIN GRATUITO PARA INTELLIJ IDEA</span>
        <h2>SmsMurilo Resilience</h2>
        <p>Analise projetos Spring Boot, confira a configuração de resiliência e encontre chamadas externas que podem precisar de proteção.</p>
        <ul>
          <li>Detecta o starter SmsMurilo Resilience e suas propriedades</li>
          <li>Oferece monitoramento opcional de endpoints de produção</li>
        </ul>
        <div class="product-actions">
          <a href="https://plugins.jetbrains.com/plugin/34453-smsmurilo-resilience" target="_blank" rel="noopener noreferrer" class="marketplace-link">Ver na JetBrains Marketplace <span>↗</span></a>
        </div>
      </div>
    </article>
  </section>

  <section class="contact-card">
    <div><span class="section-tag">VAMOS CONVERSAR</span><h2>Quer saber qual produto atende melhor ao seu desafio?</h2></div>
    <a href="mailto:smsmurilo@gmail.com?subject=Produtos%20SMS%20Murilo" class="primary-button">Falar com a SMS Murilo</a>
  </section>

  <footer class="footer">
    <div class="footer-left">
      <img src="images/logo_transp.png" alt="Logo SMS Murilo">
      <div><span>PLATAFORMA MANAGER</span></div>
    </div>
    <div class="footer-right"><span>© 2026 SMS Softwares Inteligentes</span></div>
  </footer>
</main>
